import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/api/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function VehicleList() {
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    api.get('/vehicles').then(({ data }) => {
      if (data.success) setVehicles(data.data || []);
    }).catch(() => toast.error('Erro ao carregar viaturas'));
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Viaturas</h1>
        <Link to="/vehicles/new"><Button>+ Nova</Button></Link>
      </div>
      <Card>
        <CardHeader><CardTitle>Listagem</CardTitle></CardHeader>
        <CardContent>
          <div className="divide-y">
            {vehicles.length === 0 && <p className="text-muted-foreground py-4">Nenhuma viatura encontrada.</p>}
            {vehicles.map((v) => (
              <div key={v.id} className="py-3 flex items-center justify-between">
                <div>
                  <div className="font-medium">{v.license_plate}</div>
                  <div className="text-sm text-muted-foreground">{v.model} {v.year}</div>
                </div>
                <Link to={`/vehicles/edit/${v.id}`}><Button variant="ghost" size="sm">Editar</Button></Link>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
